import styled from 'styled-components'
import { Modal } from '@navent-jobs/ui-kit/components/modal'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const ModalComponent = styled(Modal)``

export const ModalBodyComponent = styled('div')`
  background: #edf1f7;
  ${({ scrollable, height }) => scrollable && `height: calc(100vh - ${height}px);`}
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.colors.grey4};
  border-left: none;
  border-right: none;
  margin: 0 -12px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    margin: 0 -36px;
    ${({ scrollable, height }) => scrollable && `height: ${height}px;`}
  }
`

export const ModalBodyContent = styled('div')`
  margin: 12px;
`

export const CardContainer = styled('div')`
  margin: 12px 0 0 0;
`

export const ModalFooterComponent = styled('div')`
  margin: 24px 12px -24px;
`

export const CustomLink = styled(Link)`
  padding: 0 12px;

  &:first-of-type {
    margin-top: 8px;
  }

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    max-width: 200px;
    &:first-of-type {
      margin-top: 0;
    }
  }
`

export const CustomDiv = styled('div')`
  display: flex;
  justify-content: flex-end;
`

export const ContainerCheck = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  padding-top: 23px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    padding-top: 26px;
    align-items: center;
  }
`

export const ModalLegalesContent = styled('div')`
  margin: 8px 12px 20px 12px;
`
